import React, { useEffect, useState } from "react";
// styled components
import {Tabs } from "antd";
// style
import "../infoBeps/infoBeps.scss";
// components
import { CrearConvocatoria } from "./components/CrearConvocatoria";
import { CronogramaActividades } from "./components/CronogramaActividades";
import { DocumentosConvocatoria } from "./components/DocumentosConvocatoria";
// hooks
import { useInfoBeps } from "../../../../hooks/useInfoBeps";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { useEncrypt } from "../../../../hooks/useEncrypt";

export const InfoBeps = () => {
  const { decrypt } = useEncrypt();
  const { activeitem, setActiveItem } = useInfoBeps();
  
  const [tab1disabled, tab1setDisabled] = useState<boolean>();
  const [tab2disabled, tab2setDisabled] = useState<boolean>();
  const [tab3disabled, tab3setDisabled] = useState<boolean>();

  useEffect(() => {
    if (decrypt(localStorage.getItem("cambiarPestaña"))) {
      return setActiveItem(decrypt(localStorage.getItem("cambiarPestaña")));
    }
  }, [localStorage.getItem("cambiarPestaña")]);
  
  useEffect(() => {
    dehabilitarPestañas();
  }, [activeitem]);

  const dehabilitarPestañas = () => {
    if (activeitem == "1") {
      tab1setDisabled(false);
      tab2setDisabled(true);
      tab3setDisabled(true);
    } else if (activeitem == "2") {
      tab2setDisabled(false);
      tab1setDisabled(true);
      tab3setDisabled(true);
    } else if (activeitem == "3") {
      tab3setDisabled(false);
      tab1setDisabled(true);
      tab2setDisabled(true);
    }
  };

  const routes = [{nombre: "Convocatorias"},{nombre: "Crear convocatoria"}, {nombre: "BEPS"}];
  return (
    <>

      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid bg-white ps-3 pe-3">
        <div className="row">
          <div className="titulo_contenedor_tab font-family-Montserrat-SemiBold font-size-14px">
            Crear convocatoria BEPS
          </div>
        </div>
      </div>
      <Tabs
        // defaultActiveKey="1"
        activeKey={activeitem}
        // onChange={eventocambiarPestaña}

        className="height-100 container-fluid background-color-FFFFFF tabvs-convocatorias"
      >
        <Tabs.TabPane
          tab="Crear Invitación"
          key="1"
          disabled={tab1disabled}
          style={{ height: "calc(100% - 50px)" }}
          className="font-size-13px font-family-Montserrat-Regular background-color-F7FBFF"
        >
          <CrearConvocatoria cambiarPestaña={setActiveItem} />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab="Cronograma Actividades"
          key="2"
          disabled={tab2disabled}
          style={{ height: "calc(100% - 50px)" }}
          className="font-size-13px font-family-Montserrat-Regular background-color-F7FBFF"
        >
          <CronogramaActividades cambiarPestaña={setActiveItem} />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab="Documentos"
          key="3"
          disabled={tab3disabled}
          style={{ height: "calc(100% - 50px)" }}
          className="font-size-13px font-family-Montserrat-Regular background-color-F7FBFF"
        >
          <DocumentosConvocatoria cambiarPestaña={setActiveItem} />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};
